export const storageKeys = {
    DIRECTORY_LIST: 'directoryList'
}